const VideoCourse = () => import("../../components/training/VideoPlayer.vue");
const TrainingPlayer = () =>
  import("../../components/training/TrainingPlayer.vue");

require("../../css/FixTableColumn.css");
require("plyr/dist/plyr.css");

const globalComponents = {
  VideoCourse,
  TrainingPlayer,
};

const routes = [
  // URL in RAFT where Vue JS component needs to match the following.
  // Path is used in B4, Alias in B3 if they are different paths.
  {
    path: "/raft/training/player/video",
    name: "video_course",
    component: VideoCourse,
    alias: "/rafttraining/course/:course_id",
    props: true,
  },
  {
    path: "/raft/training/player/video/sections/:section",
    name: "video_course_sections",
    component: VideoCourse,
    alias: "/rafttraining/course/:course_id/sections/:section",
    props: true,
  },
  {
    path: "/raft/training/player/demo/:demo",
    name: "demo_video",
    component: TrainingPlayer,
    props: true,
  },
];

export {
  routes as trainingRoutes,
  globalComponents as trainingGlobalComponents,
};
